import React, { useEffect, useState } from 'react';
import BaseModal from './BaseModal';
import { INPUT, LABEL } from './ui';

// Themed modal for creating a form (survey). Devs additionally pick the owning
// company from a dropdown; admins/managers are locked to their own company.
const CreateFormModal = ({
  open,
  actor,
  companies = [],
  defaultCompanyId = null,
  onConfirm,
  onCancel,
}) => {
  const isDev = actor?.role === 'dev';
  const [name, setName] = useState('');
  const [companyId, setCompanyId] = useState('');

  useEffect(() => {
    if (!open) return;
    setName('');
    setCompanyId(isDev ? (defaultCompanyId || companies[0]?.id || '') : actor?.company_id || '');
  }, [open, isDev, defaultCompanyId, companies, actor]);

  const lockedCompanyName =
    actor?.company_name || companies.find((c) => c.id === actor?.company_id)?.name || '—';

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    const payload = { name: trimmed };
    if (isDev) payload.company_id = Number(companyId) || null;
    onConfirm(payload);
  };

  return (
    <BaseModal
      open={open}
      titleId="create-form-title"
      title="Create new form"
      message="Give your form a name. You can rename it later."
      onSubmit={handleSubmit}
      onCancel={onCancel}
      confirmLabel="Create"
      bodyClassName="px-6 py-4 space-y-4"
    >
      <div>
        <label htmlFor="cf-name" className={LABEL}>Name</label>
        <input
          id="cf-name"
          type="text"
          required
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Site Safety Inspection"
          className={INPUT}
        />
      </div>

      <div>
        <label htmlFor="cf-company" className={LABEL}>Company</label>
        {isDev ? (
          <select
            id="cf-company"
            value={companyId}
            onChange={(e) => setCompanyId(e.target.value)}
            className={INPUT}
            required
          >
            <option value="" disabled>Select a company</option>
            {companies.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        ) : (
          <input
            id="cf-company"
            type="text"
            value={lockedCompanyName}
            disabled
            className={`${INPUT} opacity-60 cursor-not-allowed`}
          />
        )}
      </div>
    </BaseModal>
  );
};

export default CreateFormModal;
